jQuery(document).ready(function ($) {
    let roomCode = '';
    $('.card').each(function (index, element) {
        $(element).find('button.btn').on('click', function () {
            roomCode = $.trim($(element).data('item-room-id'));
        });
    });

    document.querySelector('#modalSingUpEvent form').addEventListener('wpcf7mailsent', function () {
        if (roomCode.length > 1) {
            let ajaxUrl = `${location.protocol}//${location.hostname}${location.port ? ':' + location.port : ''}/wp-admin/admin-ajax.php`;
            let firstName = $.trim($('#modalSingUpEvent input.first-name').val());
            let lastName = $.trim($('#modalSingUpEvent input.last-name').val());
            let email = $.trim($('#modalSingUpEvent input.email-address').val());
            let country = $.trim($('#modalSingUpEvent input.country-input').val());
            let company = $.trim($('#modalSingUpEvent input.company-input').val());
            let jobTitle = $.trim($('#modalSingUpEvent input.job-title-input').val());

            $.ajax({
                url: ajaxUrl,
                type: 'POST',
                dataType: 'json',
                data: {
                    'action': 'clickmeeting_registration',
                    'firstName': firstName,
                    'lastName': lastName,
                    'email': email,
                    'country': country,
                    'company': company,
                    'jobTitle': jobTitle,
                    'roomCode': roomCode
                }
            })
        }
    })
});